import type { TextFieldProps } from "@mui/material";
import { TextField } from "@mui/material";
import { useState } from "react";
import type { ValidationResult, Validator } from "../../utilities/validators";
import { validResult } from "../../utilities/validators";

interface Props {
  name: string;
  textFieldProps: TextFieldProps;
  onValueChanged: (value: string) => void;
  doValidate: Validator<string>;
  onValidated: (value: string, validationResult: ValidationResult) => void;
}

export const TextFieldExt = ({ name, textFieldProps, onValueChanged, doValidate, onValidated }: Props) => {
  const [validationResult, setValidationResult] = useState<ValidationResult>(validResult);

  const valueChanged = (value: string) => {
    value = value.trim();
    const validationResult = doValidate(value);
    setValidationResult(validationResult);
    onValidated(name, validationResult);
  };

  const valueChanging = (value: string) => {
    const validationResult = doValidate(value);
    onValidated(name, validationResult);
    onValueChanged(value);
  };

  return (
    <TextField
      {...textFieldProps}
      onBlur={(evt) => valueChanged(evt.target.value)}
      onChange={(evt) => valueChanging(evt.target.value)}
      error={!validationResult.isValid}
      helperText={validationResult.error}
    />
  );
};

export default TextFieldExt;
